import { Form, Input } from "antd";

export default function DataFormItem(props) {
  return (
    <Form.Item
      {...props}
      name="name"
      className="w-full"
      label="Customer"
      rules={[
        {
          required: true,
          message: "Name is required",
        },
      ]}
    >
      <Input
        controls={false}
        minLength={3}
        className="w-full"
        placeholder="Enter customer name"
      />
    </Form.Item>
  );
}
